import React from 'react';

import { defaultTo, prop } from 'ramda';

import restaurant from '../../../images/bluerestaurant.svg';

import { FOHImage } from '../../ingredients';

export const FOHBlueRestaurantIcon = (props: any) => (
  <FOHImage
    source={{ uri: restaurant }}
    style={{ width: 24, height: 24, ...defaultTo({}, prop('style', props)) }}
  />
);
